import { Component } from '@angular/core';

@Component({
  selector: 'dp-chatbot-intro',
  templateUrl: './chatbot-intro.component.html',
  styleUrls: ['./chatbot-intro.component.scss'],
})
export class ChatbotIntroComponent {}
